import React from 'react'

function SettingsSynchronization() {
  return (
    <div>SettingsSynchronization</div>
  )
}

export default SettingsSynchronization;